import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private deactivedSessionError = new BehaviorSubject<string>('');

  constructor() {
 }

  setDeactivedSessionError(err: string){
    this.deactivedSessionError.next(err);
  }

  getDeactivedSessionError() : Observable<string>{
    return this.deactivedSessionError.asObservable();
  }
}
